import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useSite, money } from "@/lib/site";
import { PageHeader, Reveal, iconFor } from "@/components/site/common";
import { Approach, CtaBand } from "@/components/site/Sections";

export default function Services() {
  const { packages } = useSite();
  return (
    <>
      <PageHeader overline="Services" title="Everything you need to get found, get chosen and grow." testid="services-header">
        Strategy, paid advertising and websites — planned together so every channel pulls in the same direction.
      </PageHeader>
      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-12 sm:py-20">
        {packages.map((p, i) => {
          const Icon = iconFor(p.id);
          return (
            <Reveal key={p.id}>
              <Link to={`/services/${p.id}`} data-testid={`services-row-${p.id}`}
                className="group grid md:grid-cols-12 gap-6 items-center py-10 border-b border-slate-200 hover:bg-white transition-colors md:px-4 rounded-2xl">
                <p className="md:col-span-1 font-mono text-sm text-slate-400">0{i + 1}</p>
                <div className="md:col-span-5 flex items-start gap-4">
                  <span className="grid place-items-center w-12 h-12 shrink-0 rounded-2xl bg-blue-50 text-blue-600 transition-colors group-hover:bg-blue-600 group-hover:text-white"><Icon className="w-5 h-5" /></span>
                  <div>
                    <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">{p.name}</h2>
                    <p className="text-sm text-slate-500 mt-1">{p.tagline}</p>
                  </div>
                </div>
                <p className="md:col-span-4 text-slate-600 text-sm leading-relaxed">{p.summary}</p>
                <div className="md:col-span-2 flex md:flex-col md:items-end justify-between gap-2">
                  <p className="font-display font-bold text-slate-900">From {money(p.price)}</p>
                  <ArrowUpRight className="w-6 h-6 text-slate-400 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-blue-600" />
                </div>
              </Link>
            </Reveal>
          );
        })}
      </section>
      <Approach />
      <CtaBand />
    </>
  );
}
